import { addHours } from "date-fns/addHours";
import { DAY_COLUMN } from "../constants";
import { cn } from "@tellescope/ui";
import { useDateFnsFormattersWithLocale } from "@tellescope/ui";

export interface TimeColumnProps {
  startDate: Date;
  timezone: string;
  browserTimezone: string;
  showTwoTimezones: boolean;
  dayStartMinutes: number;
  dayEndMinutes: number;
}

export const TimeColumn = ({
  startDate,
  timezone,
  browserTimezone,
  showTwoTimezones,
  dayStartMinutes,
  dayEndMinutes,
}: TimeColumnProps) => {
  const { formatInTimeZone } = useDateFnsFormattersWithLocale();
  const visibleMinutes = dayEndMinutes - dayStartMinutes;
  const firstHour = Math.floor(dayStartMinutes / 60);
  const lastHour = Math.ceil(dayEndMinutes / 60);
  const hours = Array.from({ length: lastHour - firstHour }, (_, i) => firstHour + i);

  return (
    <div
      className="relative text-[10px] font-light overflow-hidden"
      style={{ height: visibleMinutes * DAY_COLUMN.MINUTE_HEIGHT }}
    >
      {hours.map((hour) => {
        const instant = addHours(startDate, hour + 1);
        const top = (hour * 60 - dayStartMinutes) * DAY_COLUMN.MINUTE_HEIGHT;
        return (
          <div
            key={`${hour}-left-column-time`}
            className="absolute left-0 right-0 px-2"
            style={{ top, height: DAY_COLUMN.HOUR_BLOCK_HEIGHT }}
          >
            <div
              className={cn(
                "absolute right-2 bottom-[-0.75rem] flex flex-col items-end leading-none gap-1",
                !showTwoTimezones && "bottom-[-0.25rem]"
              )}
            >
              <span className="text-muted-foreground">{formatInTimeZone(instant, timezone, "hh a")}</span>
              {showTwoTimezones && (
                <span className="text-muted-foreground/50">{formatInTimeZone(instant, browserTimezone, "hh a")}</span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
